// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__2Ly6S","title":"ClientReferral_title__1HzUv","itemText":"ClientReferral_itemText__JnlUx"};